module.exports = __webpack_public_path__ + "static/media/group_3@2x.8e59ccc6.png";